module.exports = __webpack_public_path__ + "static/media/select-dropdown.e104b6a0.svg";